import { Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  template: require('./admin-dashboard.actions.component.html')
})
export class AdminDashboardActionsComponent {
  @Input() record: any;

  @Output() onEditClick  : EventEmitter<any> = new EventEmitter();
  @Output() onDeleteClick: EventEmitter<any> = new EventEmitter();
}